import React, { useState, useEffect } from "react";
import adminApi from '../../assets/constants/AdminRafservice.Instance';
import { connect } from 'react-redux';
import { dateTimeFormatRender, anchorTagEditMode, statusToFormatRender, dateTimeAdminFormatRender } from '../../assets/constants/customRender'
import AdminSubHeader from '../../components/home/header/adminSubHeader';
import CardComponent from "../../components/Cards/card";
import ExpandableGridTable from "../../components/TableGrids/ExpandableGridTable.table";
import ServerSideGridTable from "../../components/TableGrids/ServerSideGridTable.table";
import AdminSlider from '../../components/home/header/adminSlider';
import AddModule from '../../components/Dialog/AddModule';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { purple, red } from '@mui/material/colors';
import Swal from 'sweetalert2';
import Tooltip from '@mui/material/Tooltip';
import { toast } from 'react-toastify';

const ModulePage = (props) => {
    const [moduleData, setModuleData] = useState([]);
    const [open, setOpen] = useState(false);
    const [editModuleData, setEditModuleData] = useState({});

    const moduleColumn = [
        {
            name: "title",
            label: "Name",
        },
        {
            name: "description",
            label: "Description",
        },
        {
            name: "status",
            label: "Status",
            options: statusToFormatRender
        },
        {
            name: "createdAt",
            label: "Created At",
            options: dateTimeAdminFormatRender
        },
        {
            name: "updatedAt",
            label: "Updated At",
            options: dateTimeAdminFormatRender
        },
        {
            name: "id",
            label: "Action",
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <>
                            <Tooltip title="Edit Module"><a className="hyperlink" style={{ cursor: "pointer" }} onClick={() => handleClickOpen(value)}><ModeEditOutlineIcon color="primary" /></a></Tooltip>
                            <Tooltip title="Delete Module"><a className="hyperlink" style={{ cursor: "pointer" }} onClick={() => handleClickDelete(value)}><DeleteRoundedIcon sx={{ color: red[500] }} /></a></Tooltip>
                        </>
                    );
                }
            }
        },
    ];
    useEffect(() => {
        loadModuleData();
    }, [
    ]);

    const handleClickOpen = (value = '') => {
        setOpen(true);
        if (value && value != '') {
            editLoadModuleData(value)
        } else {
            setEditModuleData({});
        }
    };

    const handleClickDelete = (value) => {
        if (value && value != '') {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this record!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                confirmBtnBsStyle: "success",
                cancelButtonText: 'No, cancel!',
                cancelBtnBsStyle: "danger",
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    adminApi.delete('/module/' + value)
                        .then(res => {
                            Swal.fire({
                                title: 'Deleted!',
                                text: 'Your record has been deleted.',
                                icon: 'success',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                    cancelButton: 'btn btn-danger',
                                }
                            })
                            loadModuleData();
                        })
                        .catch(err => {
                            toast.error(err?.response?.data?.message);
                        })
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.fire({
                        title: 'Cancelled',
                        text: 'Your record is safe :)',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                            cancelButton: 'btn btn-danger',
                        }
                    })
                }
            })
        }
    };

    const handleClose = () => {
        setOpen(false);
        setEditModuleData({});
    };

    const editLoadModuleData = (value) => {
        adminApi.get('/module/' + value)
            .then(res => {
                setEditModuleData(res.data);
            })
            .catch(err => {
                console.log(err?.response?.data?.message)
            })
    }

    const loadModuleData = () => {
        adminApi.get('/module')
            .then(res => {
                setModuleData(res.data);
            })
            .catch(err => {
                toast.error(err?.response?.data?.message);
            })
    }

    return (
        <div className="container level-summary">
            <div className="row">
                <AdminSubHeader title={'Modules'} />
                <div className='col-lg-12 pr-0 pl-0'>
                    <div className="list-member mt-4">
                        <CardComponent
                            heading={`Modules`}
                            body={
                                <>
                                    <div>
                                        <AddModule loadModuleData={loadModuleData} editModuleData={editModuleData} open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                                    </div>
                                    <ExpandableGridTable
                                        data={moduleData}
                                        columns={moduleColumn}
                                        pagination={true}
                                    ></ExpandableGridTable>
                                </>
                            }></CardComponent>
                    </div>
                </div>
            </div>
        </div>
    )
};
const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
    };
}
export default connect(mapStateToProps)(ModulePage);
